import { render } from "./FeminaCover.vue?vue&type=template&id=bd6b3eda&scoped=true"
import script from "./FeminaCover.vue?vue&type=script&lang=js"
export * from "./FeminaCover.vue?vue&type=script&lang=js"

import "./FeminaCover.vue?vue&type=style&index=0&id=bd6b3eda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6b3eda"]])

export default __exports__